import { getRuntimeConfig } from '@/lib/runtime-config';

/**
 * Runtime feature flags.
 *
 * Read from runtime config (`window.__APP_CONFIG__`), not `import.meta.env`:
 * the flag lives in the monorepo's `.env.portal`, which `vite dev` does not
 * load, and the deployed app resolves its config at runtime so one build serves
 * every environment. Set `FEATURE_ASSISTANT=true` on the app server (or
 * `VITE_FEATURE_ASSISTANT=true` in `.env.portal` for local dev) to enable it.
 *
 * (Proposals is no longer flagged — it is always on and scoped by the
 * `generate_proposals` permission, so only staff granted it see the Sales
 * section. The API enforces the same grant.)
 */
export const FEATURES = Object.freeze({
  /** The staff AI assistant panel. */
  assistant: getRuntimeConfig('FEATURE_ASSISTANT') === 'true',
});
